import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-chat-input',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss']
})
export class ChatInputComponent {
  @Input() disabled = false;
  @Output() sent = new EventEmitter<string>();

  text = '';

  send(): void {
    if (!this.text.trim() || this.disabled) return;
    this.sent.emit(this.text);
    this.text = '';
  }

  onKeydown(event: KeyboardEvent): void {
    // Enter sends, Shift+Enter adds a new line
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.send();
    }
  }
}
